import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { isAppointmentReminderNotificationDetails as typeGuard } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";

export { default } from "./NotificationAppointmentReminder.vue";

export const selector = (item: Notification): boolean => {
  return (
    typeGuard(item.details) &&
    (item.type === NotificationType.APPOINTMENT_REMINDER_PROVIDER ||
      item.type === NotificationType.APPOINTMENT_REMINDER_CONSUMER)
  );
};
